import { render, staticRenderFns } from "./GetStarted.vue?vue&type=template&id=17a9c252&scoped=true"
import script from "./GetStarted.vue?vue&type=script&lang=js"
export * from "./GetStarted.vue?vue&type=script&lang=js"
import style0 from "./GetStarted.vue?vue&type=style&index=0&id=17a9c252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a9c252",
  null
  
)

export default component.exports